.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  max-width: var(--form-max);
}

/* Widths by expected content (the `width` prop). Without it the field fills up to 720px. */
.field[data-width='xs'] {
  max-width: var(--field-xs);
}

.field[data-width='sm'] {
  max-width: var(--field-sm);
}

.field[data-width='md'] {
  max-width: var(--field-md);
}

.label {
  color: var(--ink);
  font: var(--t-body-strong);
}

.input {
  width: 100%;
  min-height: var(--control-height);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-control);
  background: var(--paper);
  color: var(--ink);
  font: var(--t-body);
  resize: vertical;
}

.input::placeholder {
  color: var(--pencil);
}

.input[data-hovered] {
  border-color: var(--graphite);
}

.input[data-focused] {
  outline: var(--focus-ring);
  outline-offset: 0;
  border-color: var(--brand);
}

.input[data-invalid] {
  border-color: var(--status-error-fg);
  outline: 1px solid var(--status-error-fg);
  outline-offset: -2px;
}

.input[data-disabled] {
  background: var(--wash);
  color: var(--pencil);
}

.description {
  color: var(--graphite);
  font: var(--t-small);
}

/* Errors are stated in words, in ink; danger red is reserved for clinical danger. */
.error {
  color: var(--ink);
  font: var(--t-small);
  font-weight: 600;
}
